import React, { Fragment } from "react";
import PropTypes from "prop-types";

import List from "@mui/material/List";
import ListSubheader from "@mui/material/ListSubheader";
import { styled } from "@mui/material/styles";

import PresentationMaterial from "~/components/PresentationMaterial";

import { materialType } from "~/constants/prop-types";

const StyledList = styled(List)(props => ({
  "&.MuiList-root": {
    padding: 0
  }
}));

const StyledHeader = styled(ListSubheader)(({ theme }) => ({
  "&.MuiListSubheader-root": { lineHeight: "32px", backgroundColor: theme.palette.mbgreen[1] }
}));

function NonAssignedPresentationMaterialsList({
  isPresentationMaterialVisible,
  materials,
  onClickHandler,
  isPresentationActive
}) {
  return (
    isPresentationActive &&
    isPresentationMaterialVisible &&
    materials.length > 0 && (
      <>
        <StyledHeader disableSticky={true}>Allgemein</StyledHeader>
        <StyledList>
          {materials.map(material => (
            <PresentationMaterial key={material._id} material={material} page={-2} onClickHandler={onClickHandler} />
          ))}
        </StyledList>
      </>
    )
  );
}

NonAssignedPresentationMaterialsList.propTypes = {
  isPresentationMaterialVisible: PropTypes.bool.isRequired,
  materials: PropTypes.arrayOf(materialType),
  onClickHandler: PropTypes.func,
  isPresentationActive: PropTypes.bool.isRequired
};

export default NonAssignedPresentationMaterialsList;
